import { Card, FC, useMemo} from 'external/react'
import { convertTimeStampToString } from 'utilities/format-date'

type PlanInfoProps = {
  subscription: any 
  lastInvoice: any
}

const PlanInfo:FC<PlanInfoProps> = props => {

  const {subscription, lastInvoice} = props
  
  const {offer_name, plan_alias, price} = subscription
  
  const nextBillingDate: false|string = useMemo(() =>
    lastInvoice === false ? false : convertTimeStampToString(lastInvoice.lines.data[0].period.end)
  , [lastInvoice])

	return (
    <div className='mt-4'>
      <div><p>Tu pago mensual</p></div>
      <Card className='mb-3'>
        <Card.Header className='header-card-color'></Card.Header>
        <Card.Body>
          <div className='d-flex justify-content-between mb-2'>
            <p style={{ fontWeight: '500', margin: '0' }}>
              {`Plan ${offer_name}`}{' '} <span className='fn-s-14 ml-1'>{`(${plan_alias})`}</span>
            </p>
            <p style={{ fontWeight: '500', margin: '0' }}>{price}</p>
          </div>
          <p style={{ margin: '0' }}>
            <span> Tu próxima fecha de facturación es el{' '} <b>{nextBillingDate}</b>.</span>
          </p>
        </Card.Body>
      </Card>
    </div>
	)
}

export {PlanInfo as default}